import styles from "./MessagesSkeleton.module.scss";
import chatStyles from "styles/chat.module.scss";

const ROWS = [
  { widths: ["90%", "60%"] },
  { widths: ["85%", "95%", "40%"] },
  { widths: ["70%"] },
  { widths: ["80%", "55%"] },
];

export default function MessagesSkeleton() {
  return (
    <main className={chatStyles.chat}>
      <div className={chatStyles.chatHeader}>
        <div className={styles.persona} />
      </div>
      <div className={chatStyles.chatBody}>
        <div className={styles.container}>
          {ROWS.map((row, i) => (
            <div key={i} className={styles.row}>
              <div className={styles.message}>
                <div className={styles.bubble}>
                  {row.widths.map((width, j) => (
                    <div key={j} className={styles.line} style={{ width }} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
